import ScrollToTop from '@utils/scrollToTop';
import { useLocation } from 'react-router-dom';
import { useDocTitle } from '@hooks/useDocTitle';
import { OutsideContainer, OutsideLayoutContent, OutsideContent } from './style';
import {
    BannerPanel,
    LogoImage,
    BannerImage,
    IconWrapper,
    FormWrapper,
    FormInner,
    BannerHeadline,
    BannerSubheadline
} from '@/pages/style';
import logoDocs from '@assets/logo-docs.png';
import { publicAsset } from '@utils/publicAsset';

const Outside = ({ children }) => {
    const location = useLocation();
    useDocTitle({ location });

    return (
        <>
            <ScrollToTop />
            <OutsideContainer>
                <OutsideLayoutContent>
                    <OutsideContent>
                        <IconWrapper>
                            <BannerPanel>
                                <LogoImage src={logoDocs} alt="Dispatchly logo" />
                                <BannerImage
                                    src={publicAsset('banner-img.png')}
                                    alt="Shipment performance preview"
                                />
                                <BannerHeadline>E-Docs Platform</BannerHeadline>
                                <BannerSubheadline>
                                    Simplify customer e-signatures and consent management in one secure platform..
                                </BannerSubheadline>
                            </BannerPanel>
                        </IconWrapper>
                        <FormWrapper>
                            <FormInner>{children}</FormInner>
                        </FormWrapper>
                    </OutsideContent>
                </OutsideLayoutContent>
            </OutsideContainer>
        </>
    );
};

export default Outside;
